<template>
    <div>
        <div>{{ $t('很遗憾，您的企业认证信息未通过！') }}</div>
        <div>{{ $t('由于以下原因，您的审核未通过。请依照各错误要求对信息予以更正完善，然后重新提交审核。') }}</div>
        <div v-for="(item, index) in error" :key="index">
            -{{ item }}
        </div>
        <div>{{ $t('欲修改的网站内公司信息、网站备案主体信息均非申请企业，请提供企点QQ号、网站授权至邮箱bqq_support@tencent.com，并请您在客户端提交修改申请，我们将根据您提供的资料进行审核。') }}</div>
        <div>
            {{ $t('或者您可以') }}
            <v-button type="link" kind="primary" @click="resetInfo">
                {{ $t('还原到上次审核通过的信息') }}
            </v-button>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        error: {
            type: Array,
            default: () => [],
        },
    },
    methods: {
        resetInfo() {
            this.$emit('resetInfo');
        },
    },
};
</script>

<style>

</style>
